import { makeStyles } from "@material-ui/core/styles";
export var useStyles = makeStyles(function (theme) { return ({
    label: {
        color: "#6D7781",
        fontSize: "15px",
        lineHeight: "140%",
        paddingRight: 60,
        width: "100%",
    },
    payButton: {
        backgroundColor: theme.palette.primary.main,
        borderRadius: "8px",
        color: "white",
        "&.Mui-disabled": {
            backgroundColor: theme.palette.primary.main,
            color: "#FFFFFF",
        },
    },
    placeholder: {
        color: "#6D7781",
    },
    toggleBtn: {
        "&.Mui-selected": {
            textTransform: "none",
            border: "0.6px solid",
            borderColor: theme.palette.primary.main,
            boxSizing: "border-box",
            backgroundColor: theme.palette.primary.main,
            color: "white",
            height: "30px",
            width: "100%",
        },
        width: "100%",
        textTransform: "none",
        border: "0.6px solid",
        borderColor: theme.palette.primary.main,
        boxSizing: "border-box",
        borderRadius: "5px",
        backgroundColor: "white",
        color: theme.palette.primary.main,
        height: "30px",
    },
}); });
